export default __webpack_public_path__ + "static/media/vision.0933d50e.svg";